/* eslint-disable */

"use client";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { MdOutlineStarPurple500 } from "react-icons/md";
import houses from "../../assets2/images/houses.svg";
import bed from "../../assets2/images/bed.svg";
import { IoMdHeart, IoMdHeartEmpty } from "react-icons/io";
import { usePreview } from "../../context/previewContext";
import { useNavigate } from "react-router-dom";
import NewFavoriteFolderModal from "../myFav/NewFavoriteFolderModal";
import AddedFavoriteModal from "../myFav/AddedFavoriteModal";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { MdDone } from "react-icons/md";
import { getEnquiries, getUser } from "../../lib/apis";
import Coupon from "../../assets2/icons/Coupon.svg";
import { base_URL } from "../../config/config";
import { DeviceType } from "../../hooks/deviceType";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { setUser } from "../../store/features/authSlice";
import { LuDot, LuPin } from "react-icons/lu";
import HotelCard from "../shared/card/hotel/HotelCard";
import {
	addVenue,
	setSelectedVenues,
} from "../../store/features/bulkEnquirySlice";
import { queueImpression } from "../../utils/impressionQueue";

function RatingComponent(ratingValue) {
	// console.log(ratingValue);
	const rating = (
		<div className="flex items-center">
			{Array.from({ length: Number(ratingValue) }).map((_, index) => (
				<MdOutlineStarPurple500
					key={index}
					className="text-[#f2c200] text-xl"
				/>
			))}
		</div>
	);

	return rating;
}
// hotels
const DetailComponent = ({
	data,
	isCompareMode,
	isSelected,
	onSelect,
	breadcrumbPath = [],
	priority = false,
}) => {
	const deviceType = DeviceType();
	const cardRef = useRef();
	const dispatch = useDispatch();
	const bulkEnquiry = useSelector((state) => state.bulkEnquiry);
	const [ratingValue, setRatingValue] = useState(0);
	const user = useSelector((state) => state.auth.user);
	const favoriteVenuesAndStay =
		user?.favoritesFolder?.map((folder) => folder.venuesAndStay).flat() || [];
	const [favItem, setFavItem] = useState(null);
	const [numberOfVenues, setNumberOfVenues] = useState(undefined);
	const [newFolder, setNewFolder] = useState(false);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isModalAddedOpen, setIsModalAddedOpen] = useState(false);
	const [isSubmittedEnquiry, setIsSubmittedEnquiry] = useState(false);
	const navigate = useNavigate();
	const getFavoriteFolder = async () => {
		try {
			const response = await fetch(
				`${base_URL}/api/auth/get-folders/${user?._id}`
			);
			if (!response.ok) {
				console.log("Failed to fetch Venues");
				return;
			}
			const data = await response.json();
			refetchFav();
			return data.folders;
		} catch (err) {
			console.log(err);
		}
	};
	const { folders, refetch } = useQuery({
		queryKey: ["favoriteFolder", user?._id],
		queryFn: getFavoriteFolder,
		enabled: !!user?._id,
	});
	const getVenuesNumber = async () => {
		try {
			const response = await axios.post(
				`${base_URL}/api/hotels/number-of-venues`,
				{
					hotelName: data?.overview?.basicDetails?.hotelName,
				}
			);
			// console.log(data?.overview?.basicDetails?.hotelName);
			// console.log(response.data.totalVenues);
			if (response.data.totalVenues !== 0) {
				setNumberOfVenues(response.data.totalVenues);
			}
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		getVenuesNumber();
	}, []);

	const handleImpression = useCallback(() => {
		queueImpression({
			venueId: data?._id,
			vendorId: data?.vendorId,
			date: new Date().toISOString(),
			deviceCategory: deviceType,
			impressions: 1,
			venueName: `${data?.overview?.basicDetails?.hotelName}, ${data?.overview?.basicDetails?.hotelChain}`,
			customerId: user?._id || "anonymous",
		});
	}, [data?._id]);
	const isFavorite = favoriteVenuesAndStay?.some(
		(favorite) => favorite.id === data._id
	);
	// Check if the end date is not in the past
	const hasOffers =
		data?.offerPackage?.length > 0 &&
		data?.offerPackage?.some((offer) => {
			const currentDate = new Date();
			const endDate = new Date(offer?.endDate);
			return endDate >= currentDate;
		});

	// const setEnquiryData = async () => {
	// 	const enquiriesData = await getEnquiries();
	// 	const venueEnquiries = enquiriesData?.hotelEnquiries;
	// 	const enquiryId = venueEnquiries?.map((enquiry) => enquiry.venueId);
	// 	if (enquiryId?.includes(data._id)) {
	// 		setIsSubmittedEnquiry(true);
	// 	}
	// };

	// useEffect(() => {
	// 	setEnquiryData();
	// }, []);

	useEffect(() => {
		setRatingValue(Number(data?.overview?.basicDetails?.hotelRating));
	}, [data]);

	useEffect(() => {
		const el = cardRef.current;
		if (!el) return;

		// Fires at 50% visibility for impression analytics
		const impressionObs = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) handleImpression();
			},
			{ threshold: 0.5 }
		);

		impressionObs.observe(el);

		return () => {
			impressionObs.disconnect();
		};
	}, [data?._id, handleImpression]);

	const slugify = (str) =>
		str
			?.toLowerCase() // make lowercase
			.replace(/[^a-z0-9]+/g, "-") // replace spaces/special chars with -
			.replace(/(^-|-$)/g, "");

	const handleViewPreviewDetails = () => {
		const cf = "hpv";
		const venueId = data?._id;
		const slug = slugify(data?.overview?.basicDetails?.hotelName);

		const updatedPath =
			breadcrumbPath?.length > 1
				? [
					...breadcrumbPath,
					{ name: data?.overview?.basicDetails?.hotelName, to: "" },
				]
				: breadcrumbPath;

		navigate(`/hotel-preview/${cf}/${venueId}/${slug}`, {
			state: updatedPath ? { breadcrumbPath: updatedPath } : undefined,
		});
	};
	useEffect(() => {
		// console.log("Data inside Stay Detail Component", data);
	}, []);

	const getUserInfo = async () => {
		const userInfo = await getUser(user?._id);
		if (userInfo) dispatch(setUser(userInfo));
		let venuesAndStay = [];
		userInfo.favoritesFolder.forEach((folder) => {
			if (folder.venuesAndStay.length > 0) {
				venuesAndStay = [...venuesAndStay, ...folder.venuesAndStay];
			}
		});
		return venuesAndStay;
	};
	const { data: userFavorites, refetch: refetchFav } = useQuery({
		queryKey: ["userFavorites"],
		queryFn: getUserInfo,
		enabled: !!user?._id,
	});

	// handling add/remove favorite
	const handleClickFavorite = async (itemId) => {
		if (!itemId) return;

		if (!user) {
			return toast.error("Please login first");
		}

		// Check if the item is already favorited
		const isFavorited =
			userFavorites &&
			userFavorites?.find((favorite) => favorite?.id === itemId);

		if (isFavorited) {
			// If already favorited, remove it
			await removeFavorite(itemId);
			refetch();
		} else {
			// If not favorited, add it
			refetch();
			setFavItem(itemId);
			user?.favoritesFolder?.length > 0
				? setIsModalAddedOpen(true)
				: setIsModalOpen(true);
		}
	};

	// remove from favs
	const removeFavorite = async (itemId) => {
		try {
			const response = await axios.post(
				`${base_URL}/api/favorite/remove-favorite`,
				{
					userId: user?._id,
					itemId,
				}
			);

			if (response?.data?.success) {
				toast.success("Removed from favorites");
				refetchFav();
			} else {
				toast.error("Failed to remove from favorites");
			}
		} catch (error) {
			console.error(error);
			toast.error("An error occurred while removing from favorites");
		}
	};

	const favoriteOverlay = () => {
		return (
			<div
				className="bg-white absolute top-3 right-4 p-1.5 rounded-full cursor-pointer"
				onClick={(e) => {
					e.stopPropagation();
					handleClickFavorite(data?._id);
				}}
			>
				{userFavorites &&
					userFavorites.find((favorite) => favorite?.id === data?._id) ? (
					<IoMdHeart className="text-primary" />
				) : (
					<IoMdHeartEmpty className="text-primary" />
				)}
			</div>
		);
	};
	const CheckboxOverlay = ({ data, handleCheckboxClick }) => {
		const selectedVenues = bulkEnquiry?.selectedVenues || [];
		const selectedIds = selectedVenues.map((venue) => venue._id);

		return (
			<>
				{bulkEnquiry?.isBulkEnquiryOpen && (
					<div
						className="absolute top-1 left-5 bg-white p-1.5 rounded-full shadow-md cursor-pointer flex items-center justify-center hover:scale-105 transition-transform"
						onClick={(e) => {
							e.stopPropagation();
							handleCheckboxClick(data?._id);
						}}
					>
						<input
							type="checkbox"
							checked={selectedIds.includes(data?._id)}
							readOnly
							className="w-[14px] h-[14px] accent-primary cursor-pointer"
						/>
					</div>
				)}
			</>
		);
	};

	const submittedOverlay = () => {
		return (
			<>
				{isSubmittedEnquiry && (
					<div className="bg-[#EAF9F7] flex justify-center items-center py-[2px] px-2 h-[25px] text-sm text-[#039f8d] absolute top-3 left-3 rounded-md cursor-pointer">
						<span>
							<MdDone className="text-md text-[#039f8d]" />
						</span>
						Enquiry Sent
					</div>
				)}
			</>
		);
	};

	const offerOverlay = () => {
		return (
			<>
				{hasOffers && (
					<div className="bg-[#fff6e6] flex justify-center items-center py-[2px] px-2 h-[25px] text-sm text-[#4B3A19] absolute bottom-3 right-3 rounded-md cursor-pointer">
						<span className="mr-1">
							<img src={Coupon} alt="" />
						</span>
						Offer Available
					</div>
				)}
			</>
		);
	};

	const pinnedOverlay = () => {
		if (!data?.isPinned) return null;
		return (
			<div className="absolute bottom-3 left-3 flex items-center gap-[5px] bg-[#E8F9F7] text-[#0D9E8E] text-xs font-medium px-2 py-[3px] rounded-md shadow-sm">
				<LuPin size={11} strokeWidth={2.5} className="-rotate-45" />
			</div>
		);
	};

	return (
		<>
			{newFolder && (
				<NewFavoriteFolderModal
					isOpen={newFolder}
					refetch={refetch}
					onClose={() => {
						setNewFolder(false);
						refetchFav();
					}}
					itemId={favItem}
					type={"venueAndStay"}
				/>
			)}
			{user?.favoritesFolder?.length > 0 ? (
				<AddedFavoriteModal
					setNewFolder={setNewFolder}
					isOpen={isModalAddedOpen}
					refetch={refetch}
					itemId={favItem}
					data={folders}
					type={"venueAndStay"}
					onClose={() => {
						setIsModalAddedOpen(false);
						refetchFav();
					}}
				/>
			) : (
				<NewFavoriteFolderModal
					isOpen={isModalOpen}
					itemId={favItem}
					refetch={refetch}
					type={"venueAndStay"}
					onClose={() => {
						setIsModalOpen(false);
						refetchFav();
					}}
				/>
			)}
			<HotelCard
				onClick={() =>
					handleViewPreviewDetails(
						data?._id,
						data?.overview?.basicDetails?.hotelName,
						user?._id
					)
				}
				ref={cardRef}
			>
				<HotelCard.Slider images={data?.photoVideo?.images} priority={priority}>
					<CheckboxOverlay
						data={data}
						handleCheckboxClick={() => dispatch(addVenue(data))}
					/>
					{favoriteOverlay()}
					{/* {submittedOverlay()} */}
					{offerOverlay()}
					{pinnedOverlay()}
				</HotelCard.Slider>
				<HotelCard.Details>
					<HotelCard.HotelName
						name={data?.overview?.basicDetails?.hotelName || "Undefined"}
						rating={ratingValue}
					>
						{ratingValue}
					</HotelCard.HotelName>
					<HotelCard.Location>
						{data?.overview?.locationDetails?.city ||
							data?.overview?.locationDetails?.area ? (
							<>
								{data?.overview?.locationDetails?.city},{" "}
								{data?.overview?.locationDetails?.area}
							</>
						) : (
							""
						)}
					</HotelCard.Location>
					<HotelCard.Icons
						houses={houses}
						room={data?.accommodation?.accommodations}
						venu={numberOfVenues}
					/>
					<HotelCard.Pricing price={data?.pricing?.basePrice} />
					<p className="text-secondary font-outfit font-normal text-[14px] leading-[156%] tracking-[0.01em] whitespace-nowrap overflow-hidden text-ellipsis">
						{data?.pricing?.selectedOptions?.[0]?.duration ||
							"Starting price per room per night"}
					</p>
				</HotelCard.Details>
			</HotelCard>
		</>
	);
};

export default DetailComponent;
